import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import { footerItems } from "../../mock_data";
import {
  typographyVerticallyCenterStyles,
  footerContainerStyles,
  linkedInFafaIconStyles,
} from "../../jsxStyles";
import instagramIcon from "../../assets/inmov-insta.svg";
import linkedinIcon from "../../assets/inmov-linkdin.svg";
import YoutubeIcon from "../../assets/inmov-youtube.svg";

const Footer = () => {
  return (
    <footer style={{ width: "100%", bottom: 0 }}>
      <Box
        sx={{
          ...footerContainerStyles,
          padding: { xs: "20px", sm: "30px", md: "40px" }, // Add padding for smaller screens
          display: "flex",
          flexDirection: {
            xl: "row",
            lg: "row",
            md: "row",
            sm: "column",
            xs: "column",
          },
        }}
      >
        {/* Footer Links */}
        <Stack
          direction="row"
          justifyContent="center"
          sx={{
            columnGap: {
              xl: "49px",
              lg: "49px",
              md: "37px",
              sm: "20px",
              xs: "10px",
            },
            flexDirection: {
              xl: "row",
              lg: "row",
              md: "row",
              sm: "column",
              xs: "column",
            },
            alignItems: "center", // Center items vertically on smaller screens
            rowGap: { sm: "10px", xs: "10px" }, // Add gap between items in column layout
          }}
        >
          {footerItems.map((item, index) => (
            <Typography
              sx={{
                ...typographyVerticallyCenterStyles,
                fontSize: { xs: "14px", sm: "16px" }, // Adjust font size for smaller screens
                cursor: "pointer",
              }}
              key={index}
              onClick={() => {
                window.open(item.link, "_blank");
              }}
            >
              {item.name}
            </Typography>
          ))}
        </Stack>

        {/* Social Icons and Website Link */}
        <Stack
          direction="row"
          justifyContent="center"
          sx={{
            marginTop: { xs: "20px", sm: "30px" },
            paddingBottom: "20px",
            columnGap: {
              xl: "20px",
              lg: "20px",
              md: "10px",
              sm: "10px",
              xs: "10px",
            },
            flexDirection: {
              xl: "row",
              lg: "row",
              md: "row",
              sm: "column",
              xs: "column",
            },
            alignItems: "center",
            rowGap: { sm: "10px", xs: "10px" },
          }}
        >
          {/* Social Icons */}
          <Box
            sx={{
              display: "flex",
              columnGap: {
                xl: "20px",
                lg: "20px",
                md: "10px",
                sm: "10px",
                xs: "10px",
              },

              alignItems: "center", // Center items vertically on smaller screens
              rowGap: { sm: "10px", xs: "10px" }, // Add gap between items in column layout
            }}
          >
            <img
              src={instagramIcon}
              alt="Instagram"
              style={{ width: "30px", cursor: "pointer" }}
              onClick={() => {
                window.open(
                  "https://www.instagram.com/inmovglobalnetwork/",
                  "_blank"
                );
              }}
            />
            <img
              src={linkedinIcon}
              alt="LinkedIn"
              style={{ width: "30px", cursor: "pointer" }}
              onClick={() => {
                window.open(
                  "https://www.linkedin.com/company/22328600/admin/dashboard/",
                  "_blank"
                );
              }}
            />
            <img
              src={YoutubeIcon}
              alt="YouTube"
              style={{ width: "30px", cursor: "pointer" }}
              onClick={() => {
                window.open(
                  "https://www.youtube.com/@InmovGlobalNetwork",
                  "_blank"
                );
              }}
            />
          </Box>

          {/* Website Link */}
          <Typography
            sx={{
              ...typographyVerticallyCenterStyles,
              fontSize: { xs: "14px", sm: "16px" }, // Adjust font size for smaller screens
              cursor: "pointer",
            }}
            onClick={() => {
              window.open("https://inmov.com/", "_blank");
            }}
          >
            https://inmov.com/
          </Typography>
        </Stack>
      </Box>
    </footer>
  );
};

export default Footer;
